import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";

import RunFrontierContainer from "containers/FrontierSliders/RunFrontier";
import ModelListContainer from "containers/Business/ModelList/ModelList";
import ScenarioSelectContainer from "containers/Project/ScenarioSelect";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import RocketIcon from "images/Next-Icons/RocketIcon.svg";

import styles from "./style.module.css";

export default class DeploySettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeployingProject: false
    };
  }

  render() {
    const {
      projectId,
      runId,
      allScenarios,
      selectedScenario,
      viewScenario,
      saveScenario,
      deployment,
      deploy,
      hasSameScenario,
      updateIsOpenScenarioSave,
      isSavingScenario
    } = this.props;

    const isCurrentDeployed = selectedScenario?.isApproved && hasSameScenario;
    const isLoadingDeploy = this.state.isDeployingProject || (deployment && !deployment.endpoint_url);
    const shouldSaveScenario = !hasSameScenario;

    return (
      <div className={styles.deploySettings}>
        <div className={styles.subTitle}>{"Your Selected Scenario"}</div>
        {shouldSaveScenario && (
          <div style={{ marginBottom: "10px" }}>
            {"You have unsaved settings. You must first save a new scenario to Deploy."}
          </div>
        )}
        {selectedScenario !== undefined &&
          selectedScenario?.isApproved !== true &&
          shouldSaveScenario !== true &&
          isLoadingDeploy !== true &&
          isSavingScenario !== true && (
            <div style={{ marginBottom: "10px" }}>
              {"Your scenario is ready to Deploy. Press Deploy AI to update your settings."}
            </div>
          )}
        {isSavingScenario ? (
          <div className={styles.saveLoad}>
            {"Saving Scenario..."}
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        ) : (
          <div className={styles.deployOptionWrapper}>
            <ScenarioSelectContainer projectId={projectId} menuPlacement={"bottom"} hideControls />
            {shouldSaveScenario && <Button onClick={() => updateIsOpenScenarioSave(true)}>{"Save Scenario"}</Button>}
            {selectedScenario !== undefined && shouldSaveScenario !== true ? (
              <div className={styles.deployButton}>
                <Button
                  type={"secondary"}
                  onClick={() => {
                    this.setState({ isDeployingProject: true });
                    return deploy(projectId).then(() => this.setState({ isDeployingProject: false }));
                  }}
                  disabled={isCurrentDeployed}
                >
                  {isLoadingDeploy ? (
                    <LoadingIndicator
                      style={{
                        width: "20px",
                        height: "18px",
                        transform: "scale(0.30)",
                        margin: "-8px 5px 5px -8px"
                      }}
                      // color={"#FFFFFF"}
                    />
                  ) : isCurrentDeployed === true ? (
                    "Deployed"
                  ) : (
                    <React.Fragment>
                      <img
                        src={ReviewDeployIcon}
                        alt="rocket icon"
                        style={{
                          marginRight: "5px",
                          height: "16px",
                          width: "16px"
                        }}
                      />
                      {"Deploy AI"}
                    </React.Fragment>
                  )}
                </Button>
              </div>
            ) : (
              <React.Fragment />
            )}
          </div>
        )}

        <div className={styles.subTitle} style={{ marginTop: "20px" }}>
          {"Optimal AI Model"}
        </div>
        <div className={styles.shotdog}>
          <ModelListContainer {...this.props} hideModelBox isNoInteractions isMini />
        </div>
        <div className={styles.subTitle} style={{ marginTop: "20px" }}>
          {"Model Portfolio to Enable Flexibility"}
        </div>
        <div className={styles.smallText}>
          {"Model Portfolio to Enable Flexibility 14 other models will be included to " +
            "improve the AI recommendations when behaviors or preferences change"}
        </div>
        <div className={styles.frontier} style={{ marginTop: "10px" }}>
          <RunFrontierContainer id={runId} projectId={projectId} />
        </div>
        {/* <div className={styles.subTitle} style={{ marginTop: "40px" }}>
          {"Aible for One Customization (Optional)"}
        </div>
        <div className={styles.smallText}>
          {"Would you like Aible for One users to be able to adjust how many Pursue " +
            "recommendations they see? If you allow adjustments Aible will select the model " +
            "optimized for the preferred level of work."}
        </div>
        <div className={styles.aButtons} style={{ marginTop: "10px" }}>
          <ButtonGroup>
            <Button>{"No Adjustments"}</Button>
            <Button active>{"Allow Adjustments"}</Button>
            <Button>{"Custom"}</Button>
          </ButtonGroup>
        </div> */}
      </div>
    );
  }
}
